<template>
    <div class="center">
        <div>
            <div class="user-list" :style="{ height: !bInvented ? '' : 'auto' }">
                <div class="top-txt" @click="getOpen(1)">
                    <div class="top-bk">
                        <div class="top-title-bef">
                            客户清单（{{ nNumber }}）
                        </div>
                        <div :class="[
                                'right_icon',
                                !bInvented ? 'noright_icon' : '',
                            ]">
                            <img src="@/assets/images/ant/details/right_icon.png" alt="" />
                        </div>
                    </div>
                </div>
                <div class="seach" v-if="!bInvented">
                    <div class="seach-input">
                        <input type="text" placeholder="请输入搜索内容" v-model="sSearch" @input="searchChange" />
                    </div>
                    <div class="seach-select" @click="bOpitem = !bOpitem">
                        <div>{{ sNameOption }}</div>
                        <div class="seach-model" v-if="bOpitem">
                            <div :class="[
                                    ckilckIndex == index ? 'ckilckColor' : '',
                                ]" @click="seachChange(item, index)" v-for="(item, index) in arrOpitem" :key="index">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="userinfo-list" v-if="!bInvented">
                    <pull-to :top-load-method="downRefresh" :bottom-load-method="upRefresh" :is-bottom-bounce="true" bottom-block-height:0 top-block-height:0 v-if="bList">
                        <div class="item" v-for="item in arrList" :key="item.id" @click="goProject(item, item.id)">
                            <!-- 用户状态 -->
                            <div class="item-top">
                                <div class="item-top-left" v-if="item.report_id != 0">
                                    方案书
                                </div>
                                <div :class="[
                                        item.report_id != 0
                                            ? 'item-top-right'
                                            : 'item-top-left',
                                        getType(item.extend),
                                    ]">
                                    {{
                                        item.extend == "" || item.extend == null
                                            ? "待分配"
                                            : item.extend
                                    }}
                                </div>
                            </div>
                            <div class="item-warp name_icon">
                                <span>{{ item.name }}</span>
                            </div>
                            <div class="item-warp phone_icon">
                                <span>{{ item.phone }}</span>
                            </div>
                            <div class="item-warp address_icon">
                                <span>{{ item.address }}</span>
                            </div>
                            <div class="right_icon">
                                <img src="~@/assets/images/ant/info/right_icon.png" alt="" />
                            </div>
                        </div>
                    </pull-to>
                    <div class="tips_text" v-else>
                        如无待跟进客户，请先进行用户报备，或建立模拟方案书
                    </div>
                </div>
            </div>
            <div class="user-list" :style="{ height: bInvented ? '' : 'auto' }">
                <div class="top-txt" @click="getOpen(1)">
                    <div class="top-bk">
                        <div class="top-title-bef">
                            虚拟方案（{{ nNumberTwo }}）
                        </div>
                        <div :class="[
                                'right_icon',
                                bInvented ? 'noright_icon' : '',
                            ]">
                            <img src="@/assets/images/ant/details/right_icon.png" alt="" />
                        </div>
                    </div>
                </div>
                <div class="userinfo-list userinfoBottom-list" v-if="bInvented">
                    <pull-to :top-load-method="downRefreshTwo" :bottom-load-method="upRefreshTwo" :is-bottom-bounce="true" bottom-block-height:0 top-block-height:0 v-if="bRepor">
                        <div class="item" v-for="(item, index) in arrRepor" :key="index" @click.stop="gorepot(item.id)">
                            <div class="proter-title">{{ item.name }}</div>
                            <div class="item-warp address_project_icon">
                                <span>{{ item.city + item.address }}</span>
                            </div>
                            <div class="right_icon">
                                <div class="del_icon" @click.stop="getConf(item.id, index)">
                                    <img src="~@/assets/images/ant/info/del_icon.png" alt="" />
                                </div>
                                <div class="desate">
                                    <img src="~@/assets/images/ant/info/right_two_icon.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </pull-to>
                    <div class="tips_text" v-else>
                        如无待跟进客户，请先进行用户报备，或建立模拟方案书
                    </div>
                </div>
            </div>
        </div>
        <div class="btn">
            <div class="adduser" @click="goAdduser">用户登录</div>
            <div class="adduser" @click="goInvented">创建模拟方案书</div>
        </div>
        <!-- 确认删除弹窗 -->
        <div class="mask" @touchmove.prevent v-if="bConfirmPopupShow">
            <div class="confirm-popup">
                <div class="popup-close" @click.stop="bConfirmPopupShow = false"></div>
                <div class="confirm-content">
                    <p>删除当前所选方案?</p>
                </div>
                <div class="confirm-btn">
                    <button @click.stop="bConfirmPopupShow = false">
                        取消
                    </button>
                    <button @click.stop="getDel()">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getWxSingleConfig, wxGetLocationH5 } from "@/js/wx.js";
import detail from "@/js/detail.js";
import PullTo from "vue-pull-to";
import oStorage from '@/libsV2/storage.js';
import { Toast } from "mint-ui";
export default {
    components: {
        Toast,
        PullTo,
    },
    data() {
        return {
            ckilckIndex: 0,
            bOpitem: false,
            arrOpitem: [
                { name: "全部", value: "" },
                // {name:'待分配',value:'待分配'},
                { name: "意向", value: "意向" },
                { name: "预售已签约", value: "预售已签约" },
                { name: "签约中", value: "签约中" },
                { name: "已签约", value: "已签约" },
                { name: "丢单", value: "丢单" },
                { name: "施工中", value: "施工中" },
                { name: "合同终止", value: "合同终止" },
                { name: "完工", value: "完工" },
            ],
            sOption: "",
            sNameOption: "全部",
            sSearch: "",
            nPage: 0, //页码
            nPageTwo: 0,
            nNumber: 0, //数量
            nNumberTwo: 0,
            arrList: [], //用户列表
            arrRepor: [], //虚拟用户
            bInvented: false,
            bLoading: false, //客户清单下一页是否有数据
            bLoadingTwo: false, //虚拟方案书下一页是否有数据
            reportId: "", //
            bConfirmPopupShow: false,
            nConfil: 0, //
            bRepor: true, //虚拟方案是否有数据
            bList: true, //用户列表是否有数据
        };
    },
    created() {
        // this.getUserlist();
        this.$storage.removeStorage("antMap");
         $init (async (res) => {
            this.$store.commit("loadSwitch", true);
            getWxSingleConfig().then(res=>{
                setTimeout(()=>{
                    wxGetLocationH5().then((res) => {
                        let addresInfo = res;
                        // localStorage.setItem("addresInfo", JSON.stringify(addresInfo));
                        oStorage.setStorage("addresInfo", JSON.stringify(addresInfo));
                    });
                    Promise.all([this.getProving(), this.getReportList()]).then(
                        (res) => {
                            this.$store.commit("loadSwitch", false);
                        }
                    );
                },400)
            });
        });
    },
    methods: {
        getConf(id, index) {
            this.reportId = id;
            this.nConfil = index;
            this.bConfirmPopupShow = true;
        },
        getType(item) {
            if (item == "意向") {
                return "backColor-one";
            } else if (item == "丢单") {
                return "backColor-fover";
            } else if (item == "已签约") {
                return "backColor-three";
            } else if (item == "施工中") {
                return "backColor-five";
            } else if (item == "完工") {
                return "backColor-six";
            } else if (item == "合同终止") {
                return "backColor-seven";
            } else if (item == "签约中") {
                return "backColor-two";
            } else if (item == "预售已签约") {
                return "backColor-eight";
            } else {
                return "backColor-night";
            }
        },
        //节流函数防抖
        debounce(fn, delay) {
            let context = this; // this指向发生变化，需要提出来
            let args = arguments;
            return (function () {
                if (context.timer) {
                    clearTimeout(context.timer);
                }
                context.timer = setTimeout(() => {
                    fn.apply(context, args);
                }, delay);
            })(); // 注意:我加了()
        },
        searchChange() {
            let _that = this;
            _that.debounce(() => {
                _that.arrList = [];
                _that.nPage = 0;
                _that.getUserlist();
            }, 500);
        },
        seachChange(item, index) {
            let _that = this;
            _that.sOption = item.value;
            _that.sNameOption = item.name;
            _that.ckilckIndex = index;
            _that.arrList = [];
            _that.nPage = 0;
            _that.getUserlist();
        },
        //删除标签
        getDel(id) {
            // console.log(1)
            let that = this;
            detail.getDel({ report_id: that.reportId }).then((res) => {
                //  console.log(res);
                Toast({
                    message: "删除成功~",
                    duration: 800,
                });
                that.arrRepor = [];
                that.getReportList();
                that.bConfirmPopupShow = false;
            });
        },
        getOpen() {
            this.bInvented = !this.bInvented;
        },
        //跳转报告详情
        gorepot(id) {
            let that = this;
            this.$store.commit("updateAntReportId", id);
            that.$router.push({
                path: `/ant/scheme?reportId=${id}&form=invented`,
            });
        },
        //报告列表
        async getReportList() {
            let that = this;
            let reportData = {
                wind_uid: 0,
                page: that.nPageTwo,
                limit: 10,
                state: 0,
            };
            that.$store.commit("loadSwitch", true);
            await detail.getReportList(reportData).then((res) => {
                //  console.log(res);
                let nNumberTwo = res.result.num;
                let arrRepor = res.result.list;
                if (that.nPageTwo == 0 && arrRepor.length == 0) {
                    that.bRepor = false;
                }
                if (arrRepor.length < 10) {
                    that.bLoadingTwo = true;
                }
                that.nNumberTwo = nNumberTwo;
                that.arrRepor = that.arrRepor.concat(arrRepor);
            });
        },
        //用户登录
        getAccountsave() {
            let that = this;
            let accountsaveData = {
                sales_id: that.$route.query.salesid,
            };
            detail.getAccountsave(accountsaveData).then((res) => {
                //  console.log("-->", res);
                this.getUserlist();
            });
        },
        //验证用户是否登录
        getProving() {
            let that = this;
            detail.getProving().then((res) => {
                //  console.log(res);
                if (res.result.state == 0) {
                    //需要判断是否有销售员id
                    if (that.$route.query.salesid != undefined) {
                        this.getAccountsave();
                    } else {
                        this.$router.replace({ path: "/ant/error" });
                        Toast({
                            message: "无企业员id",
                        });
                    }
                    // Toast({
                    //   message: "无此用户",
                    // });
                } else if (res.result.state == 1) {
                    //需要判断是否有销售员id
                    if (that.$route.query.salesid != undefined) {
                        this.getAccountsave();
                    } else {
                        this.$router.replace({ path: "/ant/error" });
                        Toast({
                            message: "无企业员id",
                        });
                    }
                } else if (res.result.state == 2) {
                    // this.getUserlist();
                    if (that.$route.query.salesid != undefined) {
                        //  console.log("state == 2");
                        this.getAccountsave();
                    } else {
                        this.$router.replace({ path: "/ant/error" });
                        Toast({
                            message: "无企业员id",
                        });
                    }
                }
            });
        },
        //获取用户列表
        async getUserlist() {
            let that = this;
            let userData = {
                page: that.nPage,
                extend: that.sOption,
                search: that.sSearch,
                limit: 10,
            };
            this.$store.commit("loadSwitch", true);
            await detail.getUserList(userData).then((res) => {
                //  console.log("用户列表信息", res);
                let nNumber = res.result.num;
                let arrList = res.result.list;
                if (that.nPage == 0 && arrList.length == 0) {
                    that.bList = false;
                } else {
                    that.bList = true;
                }
                if (arrList.length < 10) {
                    that.bLoading = true;
                }
                that.nNumber = nNumber;
                that.arrList = that.arrList.concat(arrList);
            });
        },
        //跳转添加用户信息
        goAdduser() {
            window.location.href = process.env.VUE_APP_ADDINFO_URL;
        },
        //跳转项目列表
        goProject(item, id) {
            this.$storage.setStorage("userinfo", item);
            this.$router.push({ path: `/antinfo/project?ownerid=${id}` });
        },
        //跳转虚拟项目列表
        goInvented() {
            let that = this;
            let submintData = {
                id: 0,
                name: "",
                phone: "",
                address: "",
            };
            that.$store.commit("setUserInfo", submintData);
            that.$router.push({
                path: `/antV2/basicinfo`,
            });
        },
        //下拉
        downRefresh(loaded) {
            this.nPage = 0;
            this.arrList = [];
            this.getUserlist();
            this.bLoading = false;
            loaded("done");
        },
        //上拉
        upRefresh(loaded) {
            loaded("done");
            if (this.bLoading) {
                Toast({
                    message: "没有更多了~",
                    duration: 800,
                });
                return false;
            }
            this.nPage += 1;
            this.getUserlist();
        },
        //下拉
        downRefreshTwo(loaded) {
            this.nPageTwo = 0;
            this.bLoadingTwo = true;
            this.arrRepor = [];
            this.getReportList();
            loaded("done");
        },
        //上拉
        upRefreshTwo(loaded) {
            loaded("done");
            if (this.bLoadingTwo) {
                Toast({
                    message: "没有更多了~",
                    duration: 800,
                });
                return false;
            }
            this.nPageTwo += 1;
            this.getReportList();
        },
    },
};
</script>
<style lang="scss" scoped>
::v-deep .scroll-container {
    &::-webkit-scrollbar {
        width: 0 !important;
        height: 0 !important;
        color: transparent !important;
        display: none;
    }
}
.mask {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 888;
    display: flex;
    justify-content: center;
    align-items: center;
    .confirm-popup {
        width: 652px;
        min-height: 440px;
        border-radius: 20px;
        background-color: rgb(255, 255, 255);
        padding: 40px;
        z-index: 999;
        position: relative;
        .confirm-content {
            p {
                margin: 100px;
                text-align: center;
                font-size: 34px;
                color: rgb(51, 51, 51);
                font-weight: bold;
            }
        }
        .confirm-btn {
            display: flex;
            justify-content: center;
            button:nth-child(1) {
                width: 180px;
                height: 80px;
                border-radius: 55px;
                border-width: 2px;
                border-color: rgb(51, 51, 51);
                border-style: solid;
                color: rgb(51, 51, 51);
                background-color: #fff;
                margin-right: 30px;
                font-size: 30px;
            }
            button:nth-child(2) {
                width: 180px;
                height: 80px;
                background-color: #2c7aec;
                border-radius: 55px;
                outline: none;
                color: #fff;
                font-size: 30px;
            }
        }
    }
    .popup-close {
        position: absolute;
        top: -15px;
        right: -15px;
        background: url("~@/assets/images/antV2/basicinfo/close.png") top/100%
            auto no-repeat;
        width: 42px;
        height: 42px;
        flex-shrink: 0;
    }
}
@import "index.scss";
</style>
